import React, { CSSProperties, useState, useEffect } from "react";
import Layout from "../../Layout";
import CatalogsLayout from "Components/CatalogsLayout";
import Grid, { TextFilter, SelectColumnFilter } from "Components/Grid";
import CatalogsModal from "Components/CatalogsModal";
import Buttons from "../../Components/Buttons";
import { useSelector, useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { addView, getViews, updateView } from "actions/vista";
import FormReporte from "Forms/Reporte";
import { IReport } from "Interfaces/IReport";
import ConfirmationModal from "Components/ConfirmationModal";
import { validateForm } from "../../utils";

const Reporte = () => {
  const defaultItem = {
    idVista: 0,
    codigoVista: "",
    descripcion: "",
    descripcionCorta: "",
    descripcionMenu: "",
    descripcionToolTip: "",
    orden: 0,
    idVistaPadre: 0,
    idTipoReporte: 0,
    idTipoVista: 4,
    multivista: false,
    url: "",
    rutaReporte: "",
    tipo: false,
    imagen: "",
    idEstatus: 1,
    idReport: "",
    idWorkspace: "",
  };

  const [title] = useState("Reporte");
  const [open, setOpen] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [action, setAction] = useState<string>("");
  const [reports, setReports] = useState<any>();
  const [errors, setErrors] = useState<IReport>({});
  const [formValues, setFormValues] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingGrid, setIsLoadingGrid] = useState<boolean>(true);
  const dispatch: Dispatch = useDispatch();

  const { catalogs } = useSelector((state: any) => state.theme);
  const { btnSimple } = useSelector((state: any) => state.theme);

  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: catalogs.background,
  };

  const loadReports = () => {
    getViews(0, "1,2,3").then((res) => {
      if (res) setReports(res);
      setIsLoadingGrid(false);
    });
  };

  useEffect(() => {
    loadReports();
  }, []);

  const handleAddClick = () => {
    setAction("add");
    setErrors({});
    setFormValues(defaultItem);
    setOpen(true);
  };

  const handleView = (item: any) => {
    setAction("view");
    setFormValues(item);
    setOpen(true);
  };

  const handleEdit = (item: any) => {
    //console.log(item);
    setAction("edit");
    setErrors({});
    setFormValues(item);
    setOpen(true);
  };

  const handleStatus = (item: any) => {
    item.idEstatus = item.idEstatus === 1 ? 0 : 1;
    setFormValues(item);
    setOpenConfirm(true);
  };

  const handleConfirm = () => {
    setIsLoading(true);
    let form = new FormData();
    for (let key in formValues) {
      form.append(key, formValues[key]);
    }
    updateView(formValues.idVista, form, true, true).then((res) => {
      if (res) {
        loadReports();
        setOpenConfirm(false);
        dispatch({
          type: "REMOVE_REPORTS",
        });
        dispatch({
          type: "REMOVE_REPORT_LIST",
        });
      }
      setIsLoading(false);
    });
  };

  const handleCancelConfirm = () => {
    setOpenConfirm(false);
    loadReports();
  };

  const handleOnChange = (e: any) => {
    const value: any = e.target.value;
    const id: any = e.target.id;

    let itemError: any = errors;
    delete itemError[id];
    setErrors(itemError);

    setFormValues((old: object) => {
      let valuesCurrent: any = { ...old };
      if (id === "_inputFile") {
        valuesCurrent.image = e.target.files[0];
        valuesCurrent.imagen = e.target.files[0].name;
      } else {
        valuesCurrent[id] = value;
      }

      if (id === "idTipoReporte") {
        if (parseInt(value) === 1) {
          valuesCurrent.idReport = "";
          valuesCurrent.idWorkspace = "";
          valuesCurrent.url = "SSRS";
        } else {
          valuesCurrent.rutaReporte = "";
          valuesCurrent.url = "PowerBI";
        }
      }

      return valuesCurrent;
    });
  };

  const handleAccept = () => {
    debugger;
    if (!handleValidation()) {
      return false;
    }
    setIsLoading(true);
    if (action === "add") {
      let form = new FormData();
      for (let key in formValues) {
        form.append(key, formValues[key]);
      }
      addView(form, true).then((res) => {
        if (res) {
          loadReports();
          setOpen(false);
          setFormValues({});
          dispatch({
            type: "REMOVE_REPORTS",
          });
          dispatch({
            type: "REMOVE_REPORT_LIST",
          });
        }
        setIsLoading(false);
      });
    }
    if (action === "edit") {
      let form = new FormData();
      for (let key in formValues) {
        let value = formValues[key];
        if (key === "tipo") {
        } else form.append(key, value);
      }
      updateView(formValues.idVista, form, true).then((res) => {
        if (res) {
          loadReports();
          setOpen(false);
          setFormValues({});
          dispatch({
            type: "REMOVE_REPORTS",
          });
          dispatch({
            type: "REMOVE_REPORT_LIST",
          });
        }
        setIsLoading(false);
      });
    }
  };

  const handleValidation = () => {
    const tipo = parseInt(formValues?.idTipoReporte) || 0;

    const baseSchema: any = {
      codigoVista: { message: "Ingrese el código" },
      descripcion: { message: "Ingrese la descripción" },
      descripcionMenu: { message: "Ingrese la descripción menu" },
      idVistaPadre: { message: "Selecciona la vista padre" },
      idTipoReporte: { message: "Selecciona el tipo de reporte" },
      idEstatus: { message: "Selecciona el estatus" },
      image: {
        message: "Selecciona una imagen",
        optional: true,
        validate: (value: any) => {
          if (!value) return { valid: true, message: "" };
          let rgx = /\.(gif|jpe?g|png)$/i;
          let match = value.name.match(rgx);

          if (match === null) {
            return {
              valid: false,
              message: "Formato de imagen no válido (.png .jpg)",
            };
          }

          if (parseFloat((value.size / (1024 * 1024)).toFixed(2)) > 5) {
            return {
              valid: false,
              message: "El peso de la imagen rebasa los 5MB soportados",
            };
          }

          return {
            valid: true,
            message: "",
          };
        },
      },
    };

    let schema: any = { ...baseSchema };

    if (tipo === 1) {
      // Tipo 1 (SSRS): rutaReporte obligatoria, idReport/idWorkspace pueden ser nulos
      schema.rutaReporte = { message: "Ingrese la ruta del reporte" };
      schema.idReport = { optional: true };
      schema.idWorkspace = { optional: true };
    } else if (tipo === 2) {
      // Tipo 2/3 (PowerBI u otros): idReport/idWorkspace obligatorios, rutaReporte opcional
      schema.rutaReporte = { optional: true };
      schema.idWorkspace = { optional: true };
      schema.idReport = { message: "Ingrese el ID del reporte" };
    } else if (tipo === 3) {
      schema.rutaReporte = { optional: true };
      schema.idReport = { message: "Ingrese el ID del reporte" };
      schema.idWorkspace = { message: "Ingrese el ID del workspace" };
    } else {
      // Fallback: mantener las validaciones por defecto
      schema.rutaReporte = { message: "Ingrese la ruta del reporte" };
      schema.idReport = { message: "Ingrese el ID del reporte" };
      schema.idWorkspace = { message: "Ingrese el ID del workspace" };
    }

    let isValid = validateForm({ schema, values: formValues });
    if (Object.keys(isValid).length) {
      setErrors({ ...isValid });
      return false;
    }
    return true;
  };

  const handleCancel = () => {
    setOpen(false);
    loadReports();
  };

  const columns = [
    {
      accessor: "codigoVista",
      Header: "Código",
      Filter: TextFilter,
      filter: "text",
      resizable: true,
    },
    {
      accessor: "descripcionMenu",
      Header: "Descripción Menu",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "descripcion",
      Header: "Descripción",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "vistaPadre",
      Header: "Padre",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "tipoReporte",
      Header: "Tipo Reporte",
      Filter: SelectColumnFilter,
      filter: "text",
    },
    {
      accessor: "estatus",
      Header: "Estatus",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
  ];

  const config: any = {
    actions: [
      {
        action: "view",
        tooltip: "Detalles",
        visible: false,
        handle: handleView,
        color: "#0079ab",
        icon: "search",
      },
      {
        action: "edit",
        tooltip: "Editar",
        visible: true,
        handle: handleEdit,
        color: "#ffb300",
        icon: "edit",
      },
      {
        action: "status",
        tooltip: "Estatus",
        visible: true,
        handle: handleStatus,
        color: "#00a176",
        icon: "check",
        isStatus: "idEstatus",
        colorNegative: "#f15642",
        iconNegative: "clear",
      },
    ],
  };

  return (
    <Layout theme={styles}>
      <>
        <CatalogsLayout bannerTitle={title}>
          <>
            <Grid
              columns={columns}
              data={reports || []}
              config={config}
              isLoading={isLoadingGrid}
            >
              <Buttons
                title={"Nuevo Reporte"}
                type={"add-catalog"}
                config={btnSimple}
                handleClick={handleAddClick}
              />
            </Grid>
            {open && (
              <CatalogsModal
                open={open}
                action={action}
                title={title}
                modalSize={action === "view" ? "md" : "lg"}
                isLoading={isLoading}
                handleAcceptClick={handleAccept}
                handleCancelClick={handleCancel}
              >
                <FormReporte
                  item={formValues}
                  action={action}
                  errors={errors}
                  handleOnChange={handleOnChange}
                />
              </CatalogsModal>
            )}
            {openConfirm && (
              <ConfirmationModal
                open={openConfirm}
                description={`¿Está seguro de ${
                  formValues.idEstatus === 1 ? "activar" : "desactivar"
                } el reporte?`}
                modalSize={"sm"}
                isLoading={isLoading}
                handleConfirmClick={handleConfirm}
                handleCancelClick={handleCancelConfirm}
              ></ConfirmationModal>
            )}
          </>
        </CatalogsLayout>
      </>
    </Layout>
  );
};

export default Reporte;
